/**
 * Aggiorna lo stato delle schede (contatore bozze e flag pubblicazione) nelle opzioni 
 * delle select dell'atleta e aggiorna immediatamente l'interfaccia tramite una callback.
 * * @param {('pubblica-bozza'|'elimina-bozza')} action - L'azione proveniente dall'attributo data del pulsante.
 * * @param {(value)} value - L'id atleta selezionato per puntare alla option corretta.
 * @param {Function} [callback=null] - Funzione di callback opzionale per aggiornare l'interfaccia visiva.
 * @returns {void}
 * * @example
 * aggiornaOption(actionSel, ATLETA_SELECT_INDEX, (res) => {
 * if (!res) return;
 * const { numBozze, pubbl } = res;
 * aggiornaBadgeBozzaPubblicazione(numBozze, pubbl);
 * });
 */
export function aggiornaOption(action, value, callback = null) {
    // Seleziona le opzioni dell'atleta corrente su tutte le select (desktop/mobile)
    const options = document.querySelectorAll(`option[value="${value}"]`);
    
    // Se la NodeList è vuota, interrompe l'esecuzione notificandolo alla callback
    if (options.length === 0) {
        if (typeof callback === "function") callback(null);
        return;
    } 
    
    // Dichiariamo le variabili fuori dal ciclo per poterle passare alla callback alla fine
    let ultimoNumBozze = 0;
    let ultimoPubState = options[0].dataset.pbh || 'false';

    options.forEach(option => {
        // 1. Decremento del contatore delle bozze (data-bzz)
        let numBozze = Number(option.dataset.bzz) || 0;
        
        if (numBozze > 0) {
            numBozze--;
        }
        option.setAttribute('data-bzz', numBozze);
        ultimoNumBozze = numBozze; // Salviamo il valore aggiornato

        // 2. Aggiornamento dello stato di pubblicazione (data-pbh)
        if (action === 'pubblica-bozza') {
            option.setAttribute('data-pbh', 'true');
            ultimoPubState = 'true';
        }
    });

    // Eseguiamo la callback passando i dati freschi appena calcolati
    if (typeof callback === "function") {
        callback({ 
            numBozze: ultimoNumBozze, 
            pubbl: ultimoPubState 
        });
    }
}

/**
 * Popola dinamicamente il contenuto dei popover di Bootstrap basandosi sui dati ricevuti.
 * Mappa le chiavi dell'oggetto payload con gli elementi del DOM aventi l'attributo `data-set-content`.
 * * @note Per evitare bug interni di Bootstrap 5 (perdita delle classi CSS personalizzate 
 * durante l'aggiornamento dinamico del testo), la funzione distrugge l'istanza precedente 
 * del popover tramite `.dispose()` e ne istanzia una nuova da zero.
 * * @param {Object.<string, string>} userPayload - Oggetto contenente i dati da inserire nei popover.
 * Le chiavi devono corrispondere ai valori di `data-set-content`.
 * @returns {void}
 * * @example
 * const payload = { lunedi: "Corsa 10km", martedi: "Riposo" };
 * popolaUltimaScheda(payload);
 */
export function popolaUltimaScheda( userPayload ){
  if(!userPayload) return;

  const keys = Object.keys(userPayload)

  keys.forEach( key => {
    const htmlElement = document.querySelector(`[data-set-content="${key}"]`);
    if (!htmlElement) return;

    htmlElement.setAttribute('data-bs-content', userPayload[key]);

    const oldPopover = bootstrap.Popover.getInstance(htmlElement);
    if (oldPopover) {
      oldPopover.dispose(); // Cancella il vecchio popover buggato
    }

    // Ne crea uno completamente nuovo che rilegge sia il nuovo testo che la 'custom-class'
    new bootstrap.Popover(htmlElement); 
  });
}


export function subPanelEditaGara( btn, { selectAtleti, }, garePayload, callback ){
  chiudiGestioneAtletiGara()

  const rigaGara = document.getElementById(btn.dataset.id);
  if (!rigaGara) {
    if (callback && typeof callback === "function") callback();
    return;
  };

  const elencoAtleti = Object.entries(selectAtleti).map(([uid, atleta]) => {
      const nome = atleta?.nomeCompleto
      return `<option value="${uid}">${nome}</option>`;
    }).join('');
  
  const dist = btn.dataset.id
  const titolo = btn.dataset.nomeEvento
  const raceId = btn.dataset.raceid

  const distanze = [...document.querySelectorAll(`[data-distance="${dist}"]`)]
  //1. Mappiamo le distanze della gara per la select
  const opzioniDistanze = distanze.map( d => 
    `<option value="${d.dataset.value}">${d.dataset.value} km</option>`
  ).join('');

  
  // 2. Prepariamo l'HTML della riga aggiuntiva (collassata di default per animarla)
  const subPanelHtml = `
    <tr id="riga-sub-panel" class="bg-body-tertiary">
      <td colspan="7" class="p-0 border-0">
        <div id="sub-panel-assegnazione" class="p-4 border-bottom border-warning border-opacity-25 bg-body-secondary bg-opacity-10 shadow-inner">
          
          <div class="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom border-secondary-subtle">
            <h6 class="fw-bold mb-0 text-uppercase tracking-wider small text-gold">
              <i class="bi bi-person-plus-fill me-2"></i>Gestione Obiettivo per: <span class="text-body">${titolo}</span>
            </h6>
            <button type="button" class="btn-close small" 
              data-action-elenco-gare="chiudi-sub" 
              data-sub-panel="tr_id"
              aria-label="Chiudi"></button>
          </div>

          <div class="row align-items-end g-3">
            <div class="col-md-5">
              <label for="select-atleta-gara" class="form-label fw-semibold text-secondary small text-uppercase tracking-wider">Seleziona Atleta</label>
              <select id="select-atleta-gara" class="form-select bg-body border-secondary-subtle focus-gold">
                <option value="default" selected disabled>Scegli un atleta...</option>
                ${elencoAtleti}
                </select>
            </div>

            <div class="col-md-4">
              <label for="select-distanza-atleta" class="form-label fw-semibold text-secondary small text-uppercase tracking-wider">Distanza Obiettivo</label>
              <select id="select-distanza-atleta" class="form-select bg-body border-secondary-subtle focus-gold">
                <option value="default" selected disabled>Scegli distanza...</option>
                ${opzioniDistanze}
              </select>
            </div>

            <div class="col-md-3 d-grid">
              <button id="btn-conferma-assegnazione" class="btn btn-warning text-dark fw-bold py-2 shadow-sm" 
              type="button" 
              data-action-elenco-gare="assegna-gara"
              data-raceid="${raceId}">
                <i class="bi bi-check-lg me-2"></i>Assegna Gara
              </button>
            </div>
          </div>

          <div class="mt-4">
            <span class="d-block text-secondary small fw-semibold text-uppercase tracking-wider mb-2">Atleti associati e distanze obiettivo:</span>
            <div id="badge-atleti-${raceId}" class="d-flex flex-wrap gap-2">
            </div>
          </div>

        </div>
      </td>
    </tr>
  `;

  // 3. Inseriamo la nuova riga ESATTAMENTE dopo la riga della gara cliccata
  rigaGara.insertAdjacentHTML('afterend', subPanelHtml);

  const garaPayload = garePayload[raceId];
  
  // FIX: Costruiamo l'oggetto con le chiavi allineate alla destrutturazione successiva
  const datiPerBadge = {
    iscritti: garaPayload?.iscritti || null, // Se non ci sono iscritti passiamo null in sicurezza
    raceId: raceId
  };

  if (callback && typeof callback === "function") callback(datiPerBadge);
}

/**
 * Genera la stringa HTML contenente i badge degli atleti iscritti a una gara.
 * * @param {Object} params - Oggetto parametri destrutturato.
 * @param {Object.<string, Object.<string, string>>} params.iscritti - Il dizionario degli iscritti (es: { "usr_abc123": { "Mario Rossi": "42" } }).
 * @param {string} raceId - L'ID della gara corrente (passato per l'Event Delegation).
 * @returns {string} Stringa HTML pronta per il DOM.
 */
export function badgeAtletiIscritti( badgeAtleti , callback = null) { 
  const { iscritti, raceId } = badgeAtleti
  let badgeHTML = `<p class="text-muted small fst-italic mb-0 py-2">Ancora nessun atleta iscritto a questa gara!</p>`

  if (iscritti) {
    const entries = Object.entries(iscritti);

    if (entries.length > 0) {
      badgeHTML = entries.map(([uid, sottoOggetto]) => {
    
        // Estraiamo l'unica coppia [Nome, Distanza] presente nel sotto-oggetto
        const [[nomeCompletoAtleta, distanzaAtleta]] = Object.entries(sottoOggetto);

        return `
          <span class="badge bg-body text-body border border-secondary-subtle py-2 px-3 rounded-pill d-inline-flex align-items-center gap-2 shadow-sm">
            <span class="fw-bold">${nomeCompletoAtleta}</span>
            <span class="text-primary-emphasis font-monospace small px-2 bg-primary-subtle rounded fw-semibold">${distanzaAtleta}k</span>
            
            <button type="button" 
                    class="btn p-0 border-0 bg-transparent text-danger lh-1 fs-6 btn-closest" 
                    title="Rimuovi associazione"
                    data-action-elenco-gare="rimuovi-atleta-gara"
                    data-raceid="${raceId}"
                    data-atleta-uid="${uid}">
              <i class="bi bi-x-circle-fill"></i>
            </button>
          </span>`;
      }).join('');
    }
  }

  const containerBadge = document.getElementById(`badge-atleti-${raceId}`)

  if (containerBadge) {  
    containerBadge.innerHTML = badgeHTML; // innerHTML pulisce già tutto il vecchio contenuto
    if (callback && typeof callback === "function") callback(true);
    return;
  }
  
  if (callback && typeof callback === "function") callback(false);
}


/**
 * Rimuove completamente il sotto-pannello dal DOM liberando memoria.
 */
export function chiudiGestioneAtletiGara() {
  const subPanel = document.getElementById('riga-sub-panel')
  if (subPanel) {
    subPanel.remove(); // Cancella l'elemento e tutti i suoi listener interni in un colpo solo
  }
}

/**
 * @typedef {Object} GaraDati
 * @property {string} raceid - L'ID univoco della gara su Firebase
 * @property {string} nomeEvento - Il nome della competizione
 * @property {string} localitaEvento - La città o provincia dell'evento
 * @property {string} linkEvento - URL del sito ufficiale della gara
 * @property {string} dataEvento - Data in formato ISO (YYYY-MM-DDTHH:mm)
 * @property {Object.<string, string|number>} distanze - Elenco delle distanze disponibili
 */

/**
 * @typedef {Object} GaraPayload
 * @property {GaraDati} dati - Le informazioni specifiche della gara
 * @property {Object} iscritti - Dizionario degli atleti iscritti alla gara
 */

/**
 * Popola dinamicamente il corpo della tabella con l'elenco delle gare del coach.
 * * @param {Object} DOMNodes - Oggetto contenente i nodi del DOM necessari.
 * @param {HTMLTableSectionElement} DOMNodes.tbodyGare - Il tag `<tbody>` della tabella delle gare.
 * @param {GaraPayload[]} userPayload - L'array di gare formattato proveniente dallo stato o dal database.
 * @param {Function|null} [callback=null] - Funzione di callback opzionale da eseguire dopo il rendering del DOM.
 * @returns {void}
 */
export function popolaTabellaElencoGare( { tbodyGare }, userPayload, callback = null ){
  if( !userPayload ){ return; }
  let temp = Object.keys(userPayload)
  // Se l'array è vuoto, svuotiamo i dati vecchi e mostriamo l'HTML statico di default
  if (temp.length === 0) {
    // Opzione A: Se hai tolto il messaggio dal tbody, lo rigeneri al volo solo quando serve
    tbodyGare.innerHTML = `
      <tr id="row-nessuna-gara">
          <td colspan="7" class="text-center py-5 text-secondary">
              <div class="d-flex flex-column align-items-center gap-3">
                  <i class="bi bi-calendar-x opacity-50" style="font-size: 3rem;"></i>
                  <div>
                      <h6 class="fw-semibold text-body mb-1">Nessuna gara in programma</h6>
                      <p class="small text-muted mb-0">Non ci sono ancora eventi inseriti nello storico.</p>
                  </div>
                  <button data-action="inserisci-gara" type="button" class="btn btn-sm btn-gold mt-1 btn-closest" >
                      <i class="bi bi-plus-circle me-1"></i> Aggiungi la prima gara
                  </button>
              </div>
          </td>
      </tr>`;
      
    if (callback && typeof callback === "function") callback();
    return;
  }

  // Se ci sono gare, puliamo TUTTO il tbody (incluso il template statico) e stampiamo il map
  tbodyGare.innerHTML = "";

  const payloadOrdinato = ordinamentoPerData(userPayload)

  // Generazione delle righe della tabella
  let html = payloadOrdinato.map( ( elemento, index ) => {
    const key = elemento.key;
    const { nomeEvento, localitaEvento, linkEvento, dataEvento, distanze } = userPayload[key].dati;
    const iscritti = elemento.valore.iscritti;

    // FIX 4: Controllo corretto sulla proprietà .scaduto di timeDiff
    const current = !timeDiff(dataEvento).scaduto;
    const [ data, ora ] = (dataEvento || "1970-01-01T00:00").split('T');
    const [ anno, mese, giorno ] = data.split('-')
    let dataFormat = `${giorno}-${mese}-${anno}`

    const listaDistanze = distanze ? Object.values(distanze) : [];

    const distanzeHtml = listaDistanze.length > 0 
      ? listaDistanze.map(distanza => {
          return `<span data-distance="tr_${index}"
                    class="${current ? "" : "text-secondary"} badge bg-secondary-subtle text-body border border-secondary-subtle small"
                    data-value="${distanza}">
                    ${distanza} km</span>`;
        }).join('')
      : `<span class="text-muted small fst-italic">Nessuna distanza</span>`; // Fallback visivo se vuoto

    const tempIscritti = iscritti ? Object.keys(iscritti).length : 0;

    const iscrittiHtml = `<div class="d-flex align-items-center gap-2">
                <span id="numero-iscritti-${key}" class="badge text-bg-warning text-dark fw-bold rounded-pill">${tempIscritti} Atleti</span>
                <button type="button" class="btn p-0 border-0 text-gold fs-5"
                        title="Gestisci iscrizioni" 
                        data-action-elenco-gare="gestisci-atleti-gara" 
                        data-id="tr_${index}"
                        data-raceid="${key}"
                        data-nome-evento="${nomeEvento}">
                    <i class="bi bi-person-gear"></i>
                </button>
            </div>`;

    return `<tr id="tr_${index}" class="border-bottom border-secondary-subtle">
                <td class="text-center py-3">
                ${current ? 
                  `<i class="bi bi-calendar2-check-fill text-gold fs-5" title="In programma"></i>` 
                    : `<i class="bi bi-archive-fill text-secondary fs-5" title="Archiviata"></i>`}
                </td>

                <td class="text-secondary small fw-semibold ${current ? "" : "text-decoration-line-through"}">
                    ${dataFormat}<br>
                    <span class="fw-normal opacity-75">${ora}</span>
                </td>

                <td class="${current ? "fw-semibold " : " text-secondary"}">
                    <div class="d-flex align-items-center gap-2">
                        <span>${nomeEvento}</span>
                        <a href="${linkEvento}" target="_blank" 
                        class="text-secondary link-gold opacity-75 opacity-100-hover fs-6 small" 
                        title="Vai al sito ufficiale" ${linkEvento === "" ? "hidden" : ""}>
                            <i class="bi bi-box-arrow-up-right"></i>
                        </a>
                    </div>
                </td>

                <td class="${current ? "" : " text-secondary"}">${localitaEvento}</td>

                <td class="${current ? "" : " text-secondary"}">
                    ${distanzeHtml}
                </td>

                <td>   
                  ${current ? iscrittiHtml : `<span class="text-secondary small fst-italic">Gara conclusa</span>`}
                </td>

                <td class="text-center">
                    <div class="d-flex gap-2 justify-content-center">
                        <button type="button" class="btn btn-sm btn-outline-secondary p-1 rounded btn-closest"
                                title="Modifica Gara" 
                                data-action-elenco-gare="modifica-gara" 
                                data-tr="tr_${index}"
                                data-raceid="${key}"
                                ${current ? "" : "disabled"}>
                            <i class="bi bi-pencil-square"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger p-1 rounded btn-closest"
                                title="Elimina Gara" 
                                data-action-elenco-gare="elimina-gara" 
                                data-tr="tr_${index}"
                                data-raceid="${key}"
                                data-dateid="${dataEvento}">
                            <i class="bi bi-trash3"></i>
                        </button>
                    </div>
                </td>
            </tr>`;
  }).join(''); // FIX 3: Unisce l'array in una stringa pulita senza virgole nel DOM

  tbodyGare.insertAdjacentHTML('afterbegin', html);

  if (callback && typeof callback === "function") callback(); 
}

function ordinamentoPerData(userPayload) {
  const mappaOrdinamento = [];

  for (const key in userPayload) {
    /*hasOwnProperty garantisce al 100% che tu stia manipolando solo ed esclusivamente i dati inseriti nel database, 
      ignorando qualsiasi altra proprietà o estensione che librerie esterne potrebbero aver aggiunto 
      al prototipo degli oggetti JavaScript della tua applicazione.*/
    if (userPayload.hasOwnProperty(key)) {
      // Estraiamo la data della gara (es: "2026-08-08T20:44")
      const dataStringa = userPayload[key]?.dati?.dataEvento;
      const timestamp = dataStringa ? new Date(dataStringa).getTime() : 0;

      // Salviamo il timestamp e la chiave originale
      mappaOrdinamento.push({
        key: key,
        timestamp: timestamp || 0,
        valore: userPayload[key]
      });
    }
  }

  // Ordina in base al timestamp:
  // a.timestamp - b.timestamp -> Cronologico Crescente (dal più vicino al più lontano)
  // b.timestamp - a.timestamp -> Cronologico Decrescente (dal più lontano al più vicino)
  mappaOrdinamento.sort((a, b) => a.timestamp - b.timestamp);

  return mappaOrdinamento;
}

export function popolaItemDaEliminare( keyNameSection, arrayEsercizi, index, callback = null ){

    const container = document.getElementById(`container-item-${index}`)
    container.innerHTML = ""

    let badgeHTML = arrayEsercizi.map((testoEsercizio, posIndex) => {
    if (testoEsercizio === true) return ""; 
    
    return `
      <span id="span-item-${posIndex}" class="badge bg-secondary text-info d-inline-flex align-items-center gap-2 p-2 m-1 fs-7">
        ${testoEsercizio}
        <button type="button" class="btn-close btn-close-white small" 
          title="Elimina questo elemento."  
          data-action-template="pre-elimina" 
          data-section="${keyNameSection}" 
          data-position="${posIndex}"
          data-container-index="${index}"
          aria-label="Rimuovi">
        </button>
      </span>
    `;
  }).join("");

  
  let html = `${badgeHTML || '<p class="text-muted small">Nessun elemento presente in questa sezione.</p>'}`
  container.insertAdjacentHTML('afterbegin', html )

  if (callback && typeof callback === "function") callback();
}

/**
 * Genera la stringa HTML per la vista di eliminazione/gestione dei badge.
 * Viene renderizzata nascosta di default grazie alla classe 'd-none'.
 */
function popolaVistaEliminazione(keyNameSection, panelId, arrayEsercizi, index) {

  // Usiamo "vista-eliminazione-${index}" in modo speculare all'aggiunta
  return `
  <div id="vista-eliminazione-${index}" class="d-none">
    <div class="d-flex align-items-center justify-content-between mb-3 pb-1 border-bottom border-secondary-subtle">
        <h6 class="fw-bold mb-0 text-uppercase tracking-wider small text-danger">
            <i class="bi bi-trash3 me-2"></i>Elimina Item da: <span class="text-body">${keyNameSection}</span>
        </h6>
        <button type="button" class="btn-close small" data-bs-toggle="collapse" 
          data-bs-target="#${panelId}" 
          data-action-template="chiudi-elimina-item" 
          data-ref="input_${index}"
          data-section="${keyNameSection}">
        </button>
    </div>
    
    <div id="container-item-${index}" class="mb-4"></div>

    <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-danger btn-sm fw-bold px-3" type="button" 
          title="Conferma le eliminazioni sul Database."
          data-action-template="conferma-aggiornamento-eliminati"
          data-action="delItem"
          data-section="${keyNameSection}" 
          data-panel="${panelId}"
          data-ref="input_${index}">
          <i class="bi bi-cloud-arrow-up me-2"></i>Aggiorna su DB
        </button>
    </div>
  </div>`;
}

/**
 * Renderizza l'intera tabella delle sezioni partendo dal payload memorizzato o dal DB.
 */
export function popolaEditTemplate({ tableItemTempl }, userPayload, callback = null) {
  tableItemTempl.innerHTML = "";

  if (!userPayload) return {};

  let html = Object.entries(userPayload).map(([keyNameSection, arrayItem], i) => {
    let numItem = arrayItem.length - 1;
    let index = i + 1;

    let panelId = `panel-sezione_${index}`;

    // 🔥 CORREZIONE: Passiamo l'index come quarto argomento!
    const eliminaItem = popolaVistaEliminazione(keyNameSection, panelId, arrayItem, index);
    
    return `
      <tr id="tr_${index}" class="border-bottom-0">
          <td class="text-center py-3" style="width: 50px;">
              <i class="bi bi-folder-fill text-gold fs-5" title="Macro Sezione Accordion"></i>
          </td>
          <td class="fw-semibold">
              ${keyNameSection}
          </td>
          <td style="width: 150px;">
              <div class="d-flex align-items-center gap-2">
                  <button type="button" title="Vedi ed elimina elementi."
                          data-action-template="item-sezione"
                          class="badge text-bg-warning text-dark fw-bold rounded-pill border-0 py-1.5 px-2 shadow-sm text-decoration-none animate-hover"
                          data-sezione="${keyNameSection}"
                          data-target="${panelId}"
                          data-ref="input_${index}" 
                          data-index="${index}"
                          data-update="input_${index}">
                      ${numItem} item
                  </button>
              </div>
          </td>
          <td class="text-center" style="width: 150px;">
              <div class="d-flex gap-2 justify-content-center">
                  <button type="button" class="btn btn-sm btn-outline-secondary p-1 rounded"
                      title="Aggiungi elemento (item) in questa sezione" 
                      data-action-template="add-item"
                      data-target="${panelId}"
                      data-index="${index}"
                      data-ref="input_${index}">
                      <i class="bi bi-plus-square me-2"></i>Item
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary p-1 rounded"
                      title="Rinomina Sezione" data-action-template="rinomina-sezione" data-sezione="${keyNameSection}">
                      <i class="bi bi-pencil-square"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger p-1 rounded"
                      title="Elimina Sezione e contenuto" 
                      data-action-template="elimina-sezione" 
                      data-sezione="${keyNameSection}" 
                      data-tr="tr_${index}">
                      <i class="bi bi-trash3"></i>
                  </button>
              </div>
          </td>
      </tr>

      <tr class="border-bottom border-secondary-subtle">
          <td colspan="4" class="p-0 border-0">
              <div class="collapse" id="${panelId}" data-bs-parent="#scheda-edit-template">
                  <div id="collapse-input_${index}" class="p-3 my-2 mx-3 rounded-3 border border-warning border-opacity-25 bg-body-secondary bg-opacity-25 shadow-sm">
                    
                    <div id="vista-aggiungi-${index}" class="d-block">
                      <div class="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom border-secondary-subtle">
                          <h6 class="fw-bold mb-0 text-uppercase tracking-wider small text-gold">
                              <i class="bi bi-clipboard2-check me-2"></i>Iniezione Item in: <span class="text-body">${keyNameSection}</span>
                          </h6>
                          <button type="button" class="btn-close small" data-bs-toggle="collapse" data-bs-target="#${panelId}" aria-label="Chiudi"></button>
                      </div>

                      <div class="row align-items-end g-2">
                          <div class="col-md-9">
                              <label class="form-label fw-semibold text-secondary small text-uppercase tracking-wider mb-1">
                                  Descrizione dell'Allenamento Campione
                              </label>
                              <input id="input_${index}" data-section-name="${keyNameSection}" data-target="${panelId}" type="text" 
                                class="form-control border-secondary-subtle shadow-sm fs-7"
                                placeholder="Es: 10km sostenuto...">
                          </div>
                          <div class="col-md-3 d-grid">
                              <button data-action-template="new-item" data-ref="input_${index}" 
                                class="btn btn-warning text-dark btn-sm fw-bold py-2 shadow-sm" type="button">
                                <i class="bi bi-cloud-arrow-up me-2"></i>Salva Item
                              </button>
                          </div>
                      </div>
                    </div>
                    
                    ${eliminaItem}

                  </div>
              </div>
          </td>
      </tr>`;
  }).join('');

  tableItemTempl.insertAdjacentHTML("afterbegin", html);
  
  if (callback && typeof callback === "function") callback();
}

/**
 * Popola la tabella dello storico per UNA SINGOLA settimana alla volta.
 * * @param {Object} DOM - Elementi del DOM destrutturati.
 * @param {string} key - La chiave della settimana corrente (es: "2026_23").
 * @param {Object} value - I dati dei giorni di QUELLA settimana specifica.
 * @param {Function} fnCalcolaDate - La funzione `calcolaDateSettimana`.
 */
export function popolaStorico({ tbodyStorico, headerStorico }, key, value, fnCalcolaDate) {
  // Svuotiamo sempre per evitare duplicati
  tbodyStorico.innerHTML = "";
  if (headerStorico) headerStorico.innerHTML = "";

  if (!value) return;

  const ordineGiorni = ["lunedi", "martedi", "mercoledi", "giovedi", "venerdi", "sabato", "domenica"];
  
  // Estrazione di anno e settimana dalla chiave
  const [anno, week] = key.split('_');
  const [lunedi, martedi, mercoledi, giovedi, venerdi, sabato, domenica] = fnCalcolaDate(parseInt(week), parseInt(anno));
  const mappaDate = { lunedi, martedi, mercoledi, giovedi, venerdi, sabato, domenica };

  const iconState = value['letto'] === true || value['letto'] === "true";
  
  // Filtriamo e contiamo solo i giorni reali per mantenere l'alternanza corretta
  const giorniEsistenti = ordineGiorni.filter(giorno => value[giorno]);
  let dataCorrente = null
  let htmlRighe = giorniEsistenti
  
    .map((giorno, realIndex) => {
      const itemValue = value[giorno];
      dataCorrente = mappaDate[giorno] || "Data n.d.";
      
      // Alternanza basata sull'indice reale renderizzato
      const bgRiga = realIndex % 2 === 0 ? 'bg-light-subtle' : 'bg-white';

      return `
        <tr class="${bgRiga} border-bottom border-secondary-subtle">
          <td class="text-capitalize fw-semibold py-3 ps-3" style="width: 140px;">${giorno}</td>
          <td class="text-secondary small py-3" style="width: 140px;">${dataCorrente}</td>
          <td class="text-body-secondary lh-base py-3 pe-3">${itemValue}</td>
        </tr>`;
    })
    .join('');
    
  if( value.note){
    let note = `<tr class="bg-light-subtle border-bottom border-secondary-subtle">
        <td class="text-capitalize fw-semibold py-3 ps-3" style="width: 140px;">NOTE</td>
        <td class="text-secondary small py-3" style="width: 140px;">${dataCorrente}</td>
        <td class="text-body-secondary lh-base py-3 pe-3">${value.note}</td>
      </tr>`

    htmlRighe = htmlRighe + note
  }

  // Aggiornamento dell'header unico
  if (headerStorico) {
    const badgeClass = iconState ? 'bg-success-subtle text-success border-success-subtle' : 'bg-warning-subtle text-warning border-warning-subtle';
    const icon = iconState ? 'bi-bookmark-check-fill' : 'bi-bookmark-x-fill';
    const testoStato = iconState ? 'SCHEDA LETTA' : 'DA LEGGERE';

    headerStorico.className = "col-12 d-flex flex-wrap align-items-center justify-content-center gap-3 mb-2 border-bottom pb-3 text-center";
    headerStorico.innerHTML = `
      <h4 class="m-0 fw-bold text-uppercase tracking-wide">Settimana ${week} <span class="fs-6 text-secondary fw-normal">(${anno})</span></h4>
      <span class="badge ${badgeClass} border px-3 py-2 rounded-pill d-flex align-items-center justify-content-center gap-2 small fw-bold" style="width: 150px;">
        ${testoStato} <i class="bi ${icon} fs-6"></i> 
      </span>
    `;
  }

  tbodyStorico.insertAdjacentHTML("afterbegin", htmlRighe);
}

/**
 * Rimuove visivamente la riga di una bozza dalla tabella HTML dopo l'eliminazione o la pubblicazione.
 * * @param {HTMLElement} elemDom - Il contenitore globale che contiene gli elementi delle bozze.
 * @param {string} idbozza - La chiave della bozza da rimuovere (corrispondente al data-id-tr).
 */
export function eliminaTRdaTabella(elemDom, idbozza){
  const tr = elemDom.tbodyBozze.querySelector(`[data-id-tr="${idbozza}"]`)
  if(tr){
    tr.remove()
    const numRows = elemDom.tbodyBozze.rows.length;
    elemDom.badgeBozze.textContent = numRows > 0 ? numRows : ""
  }
}

/**
 * Popola dinamicamente un accordion di Bootstrap con i template degli allenamenti.
 * * @param {HTMLElement} elemDom - Il contenitore dell'accordion nel DOM (es. il div #accordionFrasi).
 * @param {Object} dati - L'oggetto contenente le categorie e l'array di esercizi (es. { "Corsa": ["10km", "5km"], "Core": [...] }).
 * @param {Function|null} [callback=null] - Callback opzionale eseguita al termine
 */
export function popolaAccordionTemplate(elemDom, dati, callback = null) {
  // Svuota il contenitore per evitare duplicati in caso di re-render
  elemDom.innerHTML = "";

  const elem = Object.entries(dati || {});
  if (elem.length === 0) return;

  const container = [];

  elem.forEach(([categoria, esercizi], index) => {
    
    // CORRETTO: Aggiunto il return esplicito all'interno del map
    const body = esercizi.map(text_item => {
      if(text_item != true){
        return `<div class="p-2 border border-secondary-subtle bg-body rounded fs-7 elemento-trascinabile"
          draggable="true" data-testo="${text_item}" style="cursor: grab;">
          <i class="bi bi-grip-vertical me-1 text-secondary opacity-50"></i>${text_item}
        </div>`;
        ;
      }
    }).join('')
      

    // Determina se questa sezione deve partire aperta (apriamo solo la prima, index 0)
    const isFirst = index === 0;
    const collapseClass = isFirst ? "show" : "";
    const buttonClass = isFirst ? "" : "collapsed";

    // CORRETTO: Pulito l'HTML duplicato e sistemati i target dinamici
    const first = `
      <div class="accordion-item bg-transparent ${index > 0 ? 'mt-2' : ''}">
        <h2 class="accordion-header">
          <button class="accordion-button fs-7 fw-semibold ${buttonClass}" type="button" 
              data-bs-toggle="collapse" data-bs-target="#collapse_${index}" aria-expanded="${isFirst}">
            ${categoria}
          </button>
        </h2>
        <div id="collapse_${index}" class="accordion-collapse collapse ${collapseClass}" data-bs-parent="#${elemDom.id}">
          <div class="accordion-body d-flex flex-column gap-2 p-2">`;
          
    const end = `</div></div></div>`;
    
    container.push(first + body + end);
  });
  
  // Inietta l'intero blocco di accordion generato
  elemDom.insertAdjacentHTML("afterbegin", container.join(''));

  if (callback && typeof callback === "function") {
    callback(); 
  }
}

/**
 * Popola dinamicamente una tabella HTML con l'elenco delle bozze di uno specifico atleta.
 * * @param {HTMLElement} elemDom - L'elemento del DOM (es. il <tbody> della tabella) in cui iniettare le righe.
 * @param {string} uid_atleta - L'ID univoco o mascherato dell'atleta a cui appartengono le bozze.
 * @param {Object} dati - L'oggetto estratto da Firebase RTDB contenente le chiavi delle bozze (es. {"2026_24": {init: true}}).
 * @param {Function|null} opzionale - funzione da utilizzare per calcolo date
 */
export function popolaBozze(elemDom, uid_atleta, dati, fun = null) {
  // Svuota il contenitore prima di iniettare i nuovi dati per evitare duplicazioni al re-render
  elemDom.innerHTML = "";
  let date = null
  const keys = Object.keys(dati || {});
  let tr = "";

  if (keys.length > 0) {
    tr = keys.map(key => {
      if(fun){ 
        let split = key.split("_")
        date = fun( split[1], split[0])
      }
      return `<tr data-id-tr="${key}" class="border-bottom border-secondary-subtle align-middle">
          <td class="text-center py-3" style="width: 50px;">
            <i class="bi bi-calendar2-range-fill text-gold fs-5" title="Microciclo Settimanale"></i>
          </td>
          <td class="fw-semibold">
            Settimana <span class="text-secondary font-monospace ms-1">${key}</span>
          </td>
          <td>
            <div class="d-flex align-items-center gap-2">
                <span class="badge text-bg-secondary text-uppercase fw-bold rounded-pill shadow-sm fs-7 px-2">
                  ${date ? date[0]: ""} - ${date ? date[6]: ""}</span>
            </div>
          </td>
          <td class="text-center" style="width: 250px;">
              <div class="d-flex gap-2 justify-content-center">
                  <button type="button" class="btn btn-sm p-1 rounded badge-gold text-uppercase fw-bold fs-7 px-2"
                      data-action-bozza="pubblica-bozza" data-bozza="${key}" data-atleta="${uid_atleta}">
                      <i class="bi bi-send-plus mx-1"></i>Pubblica
                  </button>
                  
                  <button type="button" class="btn btn-sm btn-outline-secondary p-1 rounded"
                      data-action-bozza="edita-bozza" data-bozza="${key}" data-atleta="${uid_atleta}">
                      <i class="bi bi-pencil-square mx-1"></i>Edita
                  </button>
                  
                  <button type="button" class="btn btn-sm btn-outline-danger p-1 rounded"
                      data-action-bozza="elimina-bozza" data-bozza="${key}" data-atleta="${uid_atleta}">
                      <i class="bi bi-trash3"></i>
                  </button>
              </div>
          </td>
      </tr>`}).join('');
  } else {
    tr = `
      <tr class="border-bottom border-secondary-subtle">
        <td colspan="4" class="text-center py-5">      
          <h5 class="text-body-secondary m-0">
            <i class="bi bi-database-exclamation me-2 text-warning"></i>
            Non ci sono BOZZE in memoria per questo Atleta.
          </h5>
        </td>  
      </tr>`;
  }
  elemDom.insertAdjacentHTML("afterbegin", tr);
}

/**
 * Gestisce lo scambio di classi CSS tra la vecchia voce attiva e la nuova.
 * @param {HTMLElement|null} oldElement - Il nodo del DOM precedentemente attivo
 * @param {HTMLElement|null} newElement - Il nodo del DOM attualmente selezionato
 */
export function switchActiveLabel(oldElement, newElement) {
    // 1. Ripristiniamo il vecchio elemento (se esiste)
    if (oldElement) {
        oldElement.classList.remove('voce-attiva-custom');
        oldElement.classList.add('text-white');
    }

    // 2. Attiviamo il nuovo elemento (se esiste)
    if (newElement) {
        newElement.classList.add('voce-attiva-custom');
        newElement.classList.remove('text-white');
    }
}

/**
 * Gestisce lo scambio di classi CSS tra la vecchia voce attiva e la nuova.
 * @param {HTMLElement|null} oldElement - Il nodo del DOM precedentemente attivo
 * @param {HTMLElement|null} newElement - Il nodo del DOM attualmente selezionato
 */
export function switchTextGold(oldElement, newElement) {
    // 1. Ripristiniamo il vecchio elemento (se esiste)
    if (oldElement) {
        oldElement.classList.remove('text-gold');
    }

    // 2. Attiviamo il nuovo elemento (se esiste)
    if (newElement) {
        newElement.classList.add('text-gold');
    }
}

/**
 * Pulisce lo stato attivo da tutti i pulsanti delle settimane e ripristina il primo come attivo.
 * @returns {HTMLElement|null} Il nodo del DOM corrispondente al pulsante della prima settimana
 */
export function cleanTextGoldWeek(){
  const buttons = document.querySelectorAll('[data-edit]')
  if(!buttons) return
  buttons.forEach( btn => btn.dataset.edit != 0 ? btn.classList.remove('text-gold') : "" )
  buttons[0].classList.add('text-gold')
  return document.querySelector('#btn-week-1')
}

/**
 * Popola una select HTML con i dati degli atleti ricevuti dal backend.
 * @param {HTMLSelectElement} domElem - Il nodo del DOM della select da popolare
 * @param {Object} data - L'oggetto contenente il payload dei dati
 */
export function loadSelectAtleti(domElem, data) {
    // Controllo di sicurezza: se l'elemento del DOM non esiste o l'oggetto è vuoto, evitiamo crash
    if (!domElem) return;
    const atleti = data?.selectAtleti || {};

    const firstOption = '<option value="0" data-bzz="" data-pbh="false" selected>Seleziona Atleta...</option>';
    
    const selectOptions = Object.entries(atleti).map(([uid, atleta]) => {
      const numBozze = atleta.indici?.bozze ? Object.keys(atleta.indici.bozze).length : 0;
      const published = atleta.indici?.published?.version ? "true" : "false";
      return `<option value="${uid}" data-bzz="${numBozze}" data-pbh="${published}">${atleta.nomeCompleto}</option>`;
    }).join('');

    domElem.innerHTML = firstOption + selectOptions;
}

/**
 * Popola gli elementi testuali e i contatori della Dashboard Home.
 * * @param {Object} domElements - Oggetto contenente i riferimenti ai nodi DOM della Home.
 * @param {HTMLElement} domElements.numAtleti - Elemento che mostra il conteggio atleti.
 * @param {HTMLElement} domElements.spanNomeCoach - Elemento che mostra il nome del coach.
 * @param {HTMLElement} domElements.numGiorniNextGara - Elemento che mostra il countdown della gara.
 * @param {Object} data - Oggetto contenente i dati ricevuti dal backend (Firebase).
 */
export function updateDashHomeTitleInfo( {numAtleti, spanNomeCoach, numGiorniNextGara, numeroGare }, data) {
    // Numero atleti (fallback {} per evitare crash)
    const atleti = data?.selectAtleti || {};
    if (numAtleti) {
        numAtleti.textContent = Object.values(atleti).length || '0';
    }
    
    if (spanNomeCoach) {
        spanNomeCoach.textContent = data?.nickCoach || 'Coach';
    }

    // FIX 3: Safe check con fallback a oggetto vuoto se non ci sono gare
    const listaGare = data?.race?.lista || {};
    const ln = Object.keys(listaGare).length;

    if (numeroGare) {
        numeroGare.textContent = ln;
    }


    if (numGiorniNextGara) {
        if (ln > 0) {
            const dateGare = Object.values(listaGare).map(({ data }) => data);
            // FIX 1: Definiamo il timestamp di questo istante preciso
            const adesso = Date.now(); 
            let garePassateCount = 0;

            // Filtriamo solo le date future per trovare la PROSSIMA gara reale
            const dateFuture = dateGare.filter(d => Date.parse(d) >= adesso);

            // Conteggio gare passate
            dateGare.forEach(d => {
                if (Date.parse(d) < adesso) {
                    garePassateCount++;
                }
            });

            if (dateFuture.length > 0) {
                // FIX 2: Troviamo la data MINIMA (la più vicina cronologicamente ad adesso)
                const prossimaData = dateFuture.reduce((piuVicina, dataCorrente) => {
                    return Date.parse(dataCorrente) < Date.parse(piuVicina) ? dataCorrente : piuVicina;
                });

                // Calcolo della differenza di tempo
                const time = timeDiff(prossimaData);
                const stringGarePassate = garePassateCount > 0 ? ` (nel frattempo, ${garePassateCount} gare sono archiviate).` : ".";
                
                numGiorniNextGara.textContent = `${time.giorni} giorni, ${time.ore} ore e ${time.minuti} minuti${stringGarePassate}`;
            } else {
                // Se ci sono date nel DB ma sono tutte passate
                numGiorniNextGara.textContent = `Nessuna gara in programma. Tutte le ${garePassateCount} gare sono concluse.`;
            }
        } else {
            // Se non esiste proprio il nodo lista_date nel payload
            numGiorniNextGara.textContent = "Nessun evento pianificato.";
        }
    }
}

/**
 * Aggiorna i dati del Coach nel Dropdown del Profilo (Header o Sidebar)
 * @param {Object} domElements - Oggetto contenente i nodi del DOM del dropdown
 * @param {HTMLElement} domElements.strongNome - Il tag che contiene il nome del coach
 * @param {HTMLImageElement} domElements.imgCoach - Il tag <img> del profilo
 * @param {Object} data - Il payload dei dati dal backend
 */
export function updateCoachDropdownInfo({ strongNome, imgCoach }, data) {
    
    // Aggiorna il nome SOLO se l'elemento esiste fisicamente nel DOM di questa pagina
    if (strongNome) {
        strongNome.textContent = data?.nomeCompletoCoach || '';
    }

    // Aggiorna l'immagine SOLO se l'elemento esiste fisicamente nel DOM di questa pagina
    if (imgCoach) {
        imgCoach.src = data?.linkCoach || 'https://github.com/mdo.png'; // Fallback se non c'è foto
    }
}

/**
 * Aggiorna i dati del Coach nel Dropdown del Profilo (Header o Sidebar)
 * @param {Object} domElemDropdown - Oggetto contenente i nodi del DOM del dropdown
 * @param {HTMLElement} domElements.submitBTN - Il contenitore principale pulsante
 * @param {Boolean}  - true or false 
 */
export function loadButton( {submitBtn}, set){
  submitBtn.disabled = set;
  submitBtn.innerHTML = set ? `<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            <span role="status">Loading...</span>` : "Accedi";
}

/**
 * Mostra un toast di Bootstrap personalizzato inserendo i testi dinamicamente.
 * @param {Object} domElements - Oggetto contenente i tre nodi del DOM necessari.
 * @param {HTMLElement} domElements.toastLive - Il contenitore principale del Toast (con classe .toast).
 * @param {HTMLElement} domElements.smallToast - L'elemento per il testo piccolo (es. l'orario o la categoria).
 * @param {HTMLElement} domElements.testoToast - L'elemento per il corpo del messaggio.
 * @param {string} smallText - Il testo da inserire nella notifica piccola.
 * @param {string} bodyText - Il testo principale del messaggio.
 * @param {number|null} [delay=null] - Tempo in millisecondi prima che il toast si chiuda automaticamente (opzionale).
 */
export function showCustomToast({ toastLive, smallToast, testoToast }, smallText, bodyText, delay = null) {
    // Controllo di sicurezza: se manca il contenitore principale, interrompiamo per evitare crash
    if (!toastLive) {
        console.error("❌ Errore: Il nodo 'toastLive' non è stato trovato nel DOM.");
        return;
    }

    // 1. Aggiorniamo i testi se gli elementi esistono
    if (smallToast) smallToast.textContent = smallText;
    if (testoToast) testoToast.textContent = bodyText;

    // 2. Prepariamo la configurazione dinamica di Bootstrap
    const config = {};
    if (delay !== null) {
        config.autohide = true;
        config.delay = Number(delay);
    }

    // 3. Recuperiamo l'istanza. Se passiamo l'oggetto config, Bootstrap aggiorna i parametri interni
    const toastInstance = bootstrap.Toast.getOrCreateInstance(toastLive, config);
    
    // 4. Mostriamo il toast sullo schermo
    toastInstance.show();
}

/**************************MODALE ********************************** */

/**
 * Mostra una modale informativa e gestisce il reset del pulsante di conferma.
 * @param {Object} modalObj - L'oggetto contenente i riferimenti della modale.
 * @param {HTMLElement} modalObj.title - Elemento DOM del titolo.
 * @param {HTMLElement} modalObj.message - Elemento DOM del messaggio.
 * @param {HTMLElement} modalObj.btnConfirm - Il pulsante di conferma.
 * @param {Object} modalObj.myModal - L'istanza Bootstrap della modale.
 * @param {string} titolo - Testo del titolo.
 * @param {string} messaggio - Testo del messaggio.
 */
export function showModale(modalObj, titolo, messaggio) {
    modalObj.title.innerText = titolo;
    modalObj.message.innerText = messaggio;

    // Pulizia eventi tramite clonazione
    const nuovoBtn = modalObj.btnConfirm.cloneNode(true);
    modalObj.btnConfirm.parentNode.replaceChild(nuovoBtn, modalObj.btnConfirm);
    
    // Aggiorniamo il riferimento nell'oggetto originale
    modalObj.btnConfirm = nuovoBtn; 

    nuovoBtn.addEventListener('click', () => {
        modalObj.myModal.hide();
    });

    modalObj.myModal.show();
}

/**
 * Inizializza i listener per gestire l'accessibilità (inert) della modale.
 * @param {Object} modalObj - L'oggetto contenente il nodo DOM della modale.
 * @param {HTMLElement} modalObj.element - Il nodo DOM principale della modale (l'elemento con id="modalChoice").
 */
export function modalListener({ element }) {
    // Ora usiamo 'element' passato nei parametri, non più la variabile globale
    element.addEventListener('hide.bs.modal', () => {
        if (document.activeElement) {
            document.activeElement.blur(); 
        }
    });

    element.addEventListener('hidden.bs.modal', () => {
        element.setAttribute('inert', ''); // Usa element, non modalElement
    });

    element.addEventListener('show.bs.modal', () => {
        element.removeAttribute('inert'); // Usa element, non modalElement
    });
}

/**
 * Restituisce i dati di configurazione per il template dell'interfaccia scheda.
 * @param {string} select - La chiave identificativa della modalità ("nuovo-atleta" o "elimina-atleta").
 * @returns {Object} Oggetto contenente il layout testuale e lo stato dei bottoni.
 * @returns {string} Object.h4Titolo - HTML per il titolo del blocco.
 * @returns {string} Object.sottoTitolo - HTML o testo per il sottotitolo informativo.
 * @returns {string} Object.btnAzioneText - Testo da visualizzare sul bottone principale.
 * @returns {boolean} Object.showElimina - Flag che determina se mostrare la sezione di eliminazione.
 */
export function editTemplate(select){
  const res = {
    "nuovo-atleta": {
      title:  `Registrazione <span id="atleta-titolo-span" class="text-gold">Nuovo Atleta</span>`,
      subtitle:  'Inserisci i dati per creare il profilo e generare le credenziali di accesso' ,
      btnText:  "Inserisci",
      showElimina: false
    },
    "elimina-atleta": {
      title:  `<span class="">Elimina <span id="atleta-titolo-span" class="text-gold">Atleta</span></span>`,
      subtitle:   `<div class="alert-content"> 
                        <i class="bi bi-exclamation-triangle"></i>
                        <span class="fw-bold text-danger">ATTENZIONE! Verifica che l'Atleta selezionato sia corretto.<br>
                          Una volta cliccato su Elimina, tutti i dati verranno cancellati dal DataBase.<br>Non sarà più possibile ripristinare i dati.
                        </span>
                      </div>
                      <div class="mt-3 d-flex align-items-center justify-content-center gap-2">
                        <input class="form-check-input" type="checkbox" id="switchCheck-presa-visione">
                        <label class="badge text-bg-danger m-0" for="switchCheck-presa-visione" style="cursor: pointer;">Letto e confermo</label>
                      </div>`,
      btnText:  "",
      showElimina: true
    }
  }
  return res[select] || { h4Titolo: "", sottoTitolo: "", btnAzioneText: "", showElimina: false };
}

/**
 * Abilita o disabilita i campi di input di un form.
 * @param {HTMLFormElement} domElem - Il form da manipolare.
 * @param {boolean} set - true per disabilitare, false per abilitare.
 */
export function toggleForm(domElem, set) {
  // Array.from crea una copia statica, ottima per iterare
  Array.from(domElem.elements).forEach(campo => {
    // Escludiamo i bottoni per evitare che si disabilitino da soli 
    // (potresti voler cliccare un bottone di reset mentre gli input sono disabilitati)
    if (campo.tagName !== "BUTTON") {
      campo.disabled = set;  
    }
  });
}

/**
 * Popola automaticamente i campi di un form basandosi sulle chiavi di un oggetto.
 * @param {HTMLFormElement} formElement - Il riferimento al tag <form>.
 * @param {Object} data - L'oggetto contenente i dati (es: { nome: "Mario", email: "..." }).
 * @param {Function|null} [callback=null] - Callback opzionale eseguita al termine
 */
export function populateForm(formElement, data, callback = null) {
  Array.from(formElement.elements).forEach(campo => {
    // Verifichiamo che il campo abbia un 'name' e che sia presente nei dati
    if (campo.name && data.hasOwnProperty(campo.name)) {
      campo.value = data[campo.name];
    }
  });

  if (callback && typeof callback === "function") {callback()}
}

/**
 * Estrae i valori di tutti i campi di un form in un oggetto semplice.
 * Nota: Funziona solo per gli elementi che possiedono l'attributo 'name'.
 * * @param {HTMLFormElement} domElemForm - Il riferimento al tag <form> da cui estrarre i dati.
 * @returns {Object} Un oggetto dove le chiavi sono i 'name' degli input e i valori sono i rispettivi 'value'.
 */
export function getInputFromForm(domElemForm) {
  return Object.fromEntries(new FormData(domElemForm).entries());
}

/**
 * Configura l'interfaccia della scheda (titoli e bottoni) per una nuova creazione o per la modifica di una bozza.
 * * @param {Object} DOM - Elementi del DOM destrutturati.
 * @param {HTMLElement} DOM.titleScheda - Elemento del titolo principale.
 * @param {HTMLElement} DOM.subTitleScheda - Elemento del sottotitolo.
 * @param {NodeList|Array<HTMLButtonElement>} DOM.btnWeek - Lista dei bottoni delle settimane.
 * @param {number} numWeek - Numero della settimana di riferimento.
 * @param {"new"|"edit"} action - L'azione da eseguire ("new" o "edit").
 */
export function setScheda({ titleScheda, subTitleScheda, btnWeek }, numWeek, action) {
  const validActions = ["new", "edit"];
  if (!validActions.includes(action)) {
    console.error(`Azione "${action}" non valida per setScheda.`);
    return;
  }

  const obj = {
    "new": {
      titolo: `Nuova <span class="text-gold">Scheda Allenamento</span>`,
      sottotitolo: "Configurazione delle sessioni giornaliere e note a margine.",
      setButton: function () { 
        btnWeek.forEach((elem, index) => {
          elem.classList.remove("d-none");
          elem.removeAttribute("inert");
          
          if (elem.value !== undefined) {
            elem.value = numWeek + index;
            const targetSpan = document.getElementById(`span-week_${index}`);
            if (targetSpan) targetSpan.textContent = numWeek + index;
          }
        });
      }
    },
    "edit": {
      titolo: `Edita <span class="text-gold">Bozza</span>`,
      sottotitolo: "Edita la settimana selezionata.",
      setButton: function () {  
        btnWeek.forEach(element => {
          if (parseInt(element.dataset.edit) > 0) {
            element.classList.add("d-none");
          } else {
            element.setAttribute("inert", "true");
            element.value = numWeek;
            
            const targetSpan = document.getElementById(`span-week_0`);
            if (targetSpan) targetSpan.textContent = numWeek;
          }
        });
      }
    }
  };

  titleScheda.innerHTML = obj[action].titolo;
  subTitleScheda.innerHTML = obj[action].sottotitolo;
  obj[action].setButton();
}

export function timeDiff(time){
  const now = Date.now(); 
  const start = Date.parse(time);
  const diffInMs = start - now;

  // SICUREZZA: Se la gara è nel passato, restituisci tutto a zero
  if (diffInMs <= 0) {
    return { giorni: 0, ore: 0, minuti: 0, scaduto: true };
  }

  return {
    giorni: Math.floor(diffInMs / (1000 * 60 * 60 * 24)),
    ore: Math.floor((diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minuti: Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60)),
    scaduto: false
  };
}